import { useEffect, useState } from "react"

type PermissionStateType = PermissionState | "unsupported" | "unknown"

export function usePermissionState(name: PermissionName) {
    const [state, setState] = useState<PermissionStateType>("unknown")

    useEffect(() => {
        if (!navigator.permissions) {
            setState("unsupported")
            return
        }

        let permissionStatus: PermissionStatus | null = null

        const check = async () => {
            try {
                permissionStatus = await navigator.permissions.query({ name })
                setState(permissionStatus.state)
                permissionStatus.onchange = () => {
                    setState(permissionStatus!.state)
                }
            } catch (err) {
                setState("unknown")
            }
        }

        check()

        return () => {
            if (permissionStatus) {
                permissionStatus.onchange = null
            }
        }
    }, [name])

    return state
}
